<template>
    <div class="home">
        <!-- <div class="menus row-center">
            <div class="menu-left">
                <menu-button @click="menu === 1 ? menu = -1 : menu = 1" :selected="menu === 1" :bg="[
                        require('../assets/img/button.png'),
                        require('../assets/img/button_c.png'),
                    ]" :icons="[
                        require('../assets/img/park.png'),
                        require('../assets/img/park_c.png'),
                    ]" content="园区总览" @onSelected="parkOverview">
                </menu-button>
            </div>
            <div class="menu-right row-center">
                <menu-button v-if="transformer" @click="menu === 2 ? menu = -1 : menu = 2" :selected="menu === 2" :bg="[
                        require('../assets/img/button.png'),
                        require('../assets/img/button_c.png'),
                    ]" :icons="[
                        require('../assets/img/tem.png'),
                        require('../assets/img/tem_c.png'),
                    ]" content="变压器监测" @onSelected="sendMessage('transformerOverview')"
                    @onUnselected="sendMessage('clearTransformerOverview')">
                </menu-button>
                <menu-button v-if="cabinetList" @click="menu === 3 ? menu = -1 : menu = 3" :selected="menu === 3" :bg="[
                        require('../assets/img/button.png'),
                        require('../assets/img/button_c.png'),
                    ]" :icons="[
                        require('../assets/img/prop.png'),
                        require('../assets/img/prop_c.png'),
                    ]" content="进线监测" @onSelected="sendMessage('propertyOverview')"
                    @onUnselected="sendMessage('clearPropertyOverview')">
                </menu-button>
                <menu-button v-if="monitor" @click="menu === 4 ? menu = -1 : menu = 4" :selected="menu === 4" :bg="[
                        require('../assets/img/button.png'),
                        require('../assets/img/button_c.png'),
                    ]" :icons="[
                        require('../assets/img/safety.png'),
                        require('../assets/img/safety_c.png'),
                    ]" content="安防监控" @onSelected="sendMessage('siteSafety')"
                    @onUnselected="sendMessage('clearSiteSafety')"></menu-button>
                <menu-button v-if="lowVoltageFeeder && areaId !== '2'" @click="menu === 5 ? menu = -1 : menu = 5" :selected="menu === 5"
                    :bg="[
                        require('../assets/img/button.png'),
                        require('../assets/img/button_c.png'),
                    ]" :icons="[
                        require('../assets/img/electric.png'),
                        require('../assets/img/electric_c.png'),
                    ]" content="馈电回路"
                    @onSelected="sendMessage('siteElectric'),showDeviceList = !showDeviceList,$refs.CabinetList.showList = true"
                    @onUnselected="sendMessage('clearSiteElectric'),showDeviceList = !showDeviceList,$refs.CabinetList.showList = false">
                </menu-button>
            </div>
        </div> -->

        <!-- <CabinetList v-show="!showDeviceList" ref="CabinetList" :areaId="$route.params.id" @showLoop="showLoop"
            @showLoopDetail="showLoopDetail" />
        <DeviceDetail v-show="showDeviceList" ref="DeviceDetail" :areaId="$route.params.id" @showDevice="showDevice" /> -->

        <div class="menus row-center">
            <div class="menu-left">
            </div>
            <div class="menu-right row-center">
                <menu-button v-if="monitor" @click="menu === 4 ? menu = -1 : menu = 4" :selected="menu === 4" :bg="[
                        require('../assets/img/button.png'),
                        require('../assets/img/button_c.png'),
                    ]" :icons="[
                        require('../assets/img/safety.png'),
                        require('../assets/img/safety_c.png'),
                    ]" content="安防监控" @onSelected="sendMessage('siteSafety')"
                    @onUnselected="sendMessage('clearSiteSafety')">
                </menu-button>
            </div>
        </div>

        <ChangeSite :areaId="$route.params.id" />
        <ElectricChart :paramType="'AREA_ID'" :areaId="$route.params.id" />
        <SiteOverView :areaId="$route.params.id" />
        <SiteOperationData :areaId="$route.params.id" />
        <Surveillance ref="Surveillance" :areaId="$route.params.id" :iframeWin="iframeWin" />
        <Distribution :areaId="$route.params.id" />

        <div class="deviceTable">
            <DeviceTable :areaId="$route.params.id" @showDevice="showDevice" ref="DeviceTable" @showLoop="showLoop">
            </DeviceTable>
        </div>

        <iframe name="THREE" id="#iframe" frameborder="0" width="100%" height="100%" ref="iframeThree"
            :src="url + $store.getters.getThreeUrl(areaId)">
        </iframe>

        <!-- <iframe name="THREE" id="#iframe" frameborder="0" width="100%" height="100%" ref="iframeThree"
            src="http://127.0.0.1:5500/public/level/CSKT_CF.html">
        </iframe>  -->
    </div>
</template>

<script>
    import ChangeSite from "./contentBlock/ChangeSite"
    import SiteOverView from './contentBlock/SiteOverView';
    import ElectricChart from './contentBlock/ElectricChart';
    import SiteOperationData from './contentBlock/SiteOperationData';
    import Surveillance from './contentBlock/Surveillance';
    import Distribution from './contentBlock/Distribution';
    import DeviceDetail from "./contentBlock/DeviceDetail";
    import CabinetList from "./contentBlock/CabinetList";
    import MenuButton from "../components/MenuButton";
    import DeviceTable from "./contentBlock/DeviceTable";
    import {
        config
    } from '../config'
    import {
        GetDeviceClassNum,
        GetDeviceNumberByAreaId,
    } from "../components/Request"

    export default {
        name: "Site",
        components: {
            ChangeSite,
            SiteOverView,
            ElectricChart,
            SiteOperationData,
            Surveillance,
            Distribution,
            MenuButton,
            DeviceDetail,
            CabinetList,
            DeviceTable,
        },
        data() {
            return {
                // 用于底部菜单导航
                menu: 0,
                url: config.threeUrl,
                iframeWin: null,
                showDeviceList: true,
                transformer: 0,
                cabinetList: 0,
                monitor: 0,
                lowVoltageFeeder: 0,
            };
        },
        created() {
            this.areaId = this.$route.params.id
            // this.$nextTick(() => {
            //     console.log(this.$refs.iframeThree)
            //     this.iframeWin = this.$refs.iframeThree.contentWindow;
            //     window.addEventListener("message", this.handleMessage);
            // })
        },
        // watch: {
        //     "$store.state.allThreeUrl": function(n){
        //         console.log(n)
        //         this.iframeWin = this.$refs.iframeThree.contentWindow;
        //     }
        // },
        mounted() {
            GetDeviceNumberByAreaId({
                areaId: this.areaId
            }).then(({
                data
            }) => {
                this.transformer = data.data.transformerDevice.length
                this.cabinetList = data.data.cabinetDevice.length
                this.monitor = data.data.securityDevice.length
                this.lowVoltageFeeder = data.data.lowVoltageFeederDetails.length
            })
            this.iframeWin = this.$refs.iframeThree.contentWindow;
            window.addEventListener("message", this.handleMessage);
            // 判断iframe是否加载完毕，无法判断threejs场景是否加载完毕
            // var _this = this
            // const iframe = document.getElementById('#iframe')
            // // 处理兼容行问题
            // if (iframe.attachEvent) {
            //     iframe.attachEvent('onload', function () {
            //         console.log('iframe已加载完毕')
            //         _this.iframeWin.postMessage({
            //             cmd: 'noDetailUI',
            //         }, "*")
            //     })
            // } else {
            //     iframe.onload = function () {
            //         console.log('iframe已加载完毕')
            //         _this.iframeWin.postMessage({
            //             cmd: 'noDetailUI',
            //         }, "*")
            //     }
            // }
            // setTimeout(() => {
            //     this.iframeWin = this.$refs.iframeThree.contentWindow;
            //     window.addEventListener("message", this.handleMessage);
            // }, 1000)
        },
        beforeDestroy() {
            window.removeEventListener("message", this.handleMessage);
        },
        methods: {
            parkOverview() {
                this.$router.push({
                    path: "/"
                });
            },
            clearparkOverview() {},
            sendMessage(value) {
                if (!value.includes('clear')) {
                    this.$refs.DeviceTable.showList = false
                    this.$refs.DeviceTable.showDetail = false
                    this.$refs.DeviceTable.height = this.$refs.DeviceTable.list.length < 3 ? 1700 : 2200
                    this.$nextTick(() => {
                        this.$refs.DeviceTable.showList = true
                    })
                }
                this.iframeWin.postMessage({
                    cmd: value,
                }, "*");
            },
            handleMessage(event) {
                // console.log(event);
                const data = event.data;
                switch (data.cmd) {
                    case "returnData":
                        console.log("得到html数据:" + data.params.data);
                        break;
                    // case "ThreeLoadEnd":
                    //     this.iframeWin.postMessage({
                    //         cmd: 'noDetailUI',
                    //     }, "*")
                    //     break;
                    case "showDeviceDetail":
                        // console.log(data.params.data)
                        this.$refs.DeviceTable.showDetail = true
                        this.$refs.DeviceTable.modelId = data.params.data
                        break;
                    case "showMonitorDetail":
                        // console.log(data.params.data)
                        this.$refs.Surveillance.currentDetails = data.params.data - 1
                        break;
                    case "showLoopTable":
                        // this.$refs.DeviceTable.modelId = data.id
                        this.$refs.DeviceTable.showLoopTable = true
                        break;
                    case "changeDevice":
                        this.menu = -1
                        this.$refs.DeviceTable.modelId = data.id
                        break;
                    case "clearTable":
                        this.$refs.DeviceTable.showDetail = false
                        this.$refs.DeviceTable.showLoopTable = data.show == 'true' ? true : false
                        break;
                    case "highLightByLoopModelID":
                        this.$refs.DeviceTable.currentLoopModelID = data.id
                        break;
                    
                }
            },

            // showDevice(IDArr, currentID) {
            //     this.menu = -1
            //     this.iframeWin.postMessage({
            //         cmd: 'showDevice',
            //         IDArr: IDArr,
            //         currentID: currentID,
            //     }, "*");
            // },
            showDevice(type, deviceInfo) {
                this.menu = -1
                if (type == '变压器') type = '变压设备'
                this.iframeWin.postMessage({
                    cmd: 'showDevice',
                    type: type,
                    deviceInfo: deviceInfo,
                }, "*")
            },
            // showLoop(deviceId, modelId, loopsArr) {
            //     this.iframeWin.postMessage({
            //         cmd: 'showLoops',
            //         deviceId: deviceId,
            //         modelId: modelId,
            //         loopsArr: loopsArr,
            //     }, "*");
            // },
            showLoop(deviceModelID, loopModelID) {
                this.iframeWin.postMessage({
                    cmd: 'showLoop',
                    deviceModelID,
                    loopModelID,
                }, "*");
            },
            showLoopDetail(label, loopId, modelId, loopsArr, allLoopsArr) {
                this.iframeWin.postMessage({
                    cmd: 'showLoopDetail',
                    label: label,
                    loopId: loopId,
                    modelId: modelId,
                    loopsArr: loopsArr,
                    allLoopsArr: allLoopsArr
                }, "*");
            }
        },
    };
</script>


<style lang="less" scoped>
    .menus {
        .w(1015);
        position: fixed;
        .wh(449, 54);
        left: @w;
        bottom: @h;
        justify-content: space-between;
        .menu-left {
            width: 160 / 1015 * 100%;
            align-self: flex-end;
        }

        .menu-right {
            width: (1 - 160 / 1015) * 100%;
            justify-content: flex-end;
            
            align-self: flex-end;

            .btn {
                .wh(16, 0);
                margin-left: @w;
            }
        }
    }

    .deviceTable {
        position: fixed;
        .wh(449, 54);
        left: @w;
        bottom: @h;
    }

    .home {
        margin: 0;
        padding: 0;
        width: 100vw;
        height: 100vh;
        overflow: hidden;
    }
</style>